import ConfigurableFlexContainer from './_configurable-flex-container.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableText from './_configurable-text.js'

export default {
  name: 'Text',
  values: {
    truncate: false,
    isHtml: false,
    ellipsisOnLineNumber: 1,
    container: {
      display: undefined,
      width: undefined,
      height: undefined,
      $mixin: [
        {
          configSet: ConfigurableFlexContainer,
        },
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
      ],
    },
    style: {
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
